import React from "react";
import { selectOnFocus } from "../../lib/inputHelpers";

export default function PieceStepper({ value, onChange, disabled, testId }) {
  const v = +value || 0;
  return (
    <div className={`flex items-center gap-1 border border-[#E5E2DC] rounded-lg overflow-hidden ${disabled ? "opacity-40" : ""}`}>
      <button
        disabled={disabled}
        onClick={() => onChange(Math.max(0, v - 1))}
        className="w-7 h-8 hover:bg-[#F0EFEA] disabled:cursor-not-allowed text-[#4F4F4D]"
        data-testid={`${testId}-minus`}
      >−</button>
      <input
        type="number" min="0" step="1" inputMode="numeric"
        value={v}
        disabled={disabled}
        onFocus={selectOnFocus}
        onChange={(e) => onChange(parseInt(e.target.value) || 0)}
        className="w-10 text-center bg-transparent text-sm font-mono outline-none"
        data-testid={`${testId}-input`}
      />
      <button
        disabled={disabled}
        onClick={() => onChange(v + 1)}
        className="w-7 h-8 hover:bg-[#F0EFEA] disabled:cursor-not-allowed text-[#4F4F4D]"
        data-testid={`${testId}-plus`}
      >+</button>
    </div>
  );
}
